const createGeometry = (coordinates, id) => {
    if (coordinates.length > 1) {
        return {
            "type": "GeometryCollection",
            "geometries": coordinates.map(c => {
                return {
                    "type": "Polygon",
                    "coordinates": c
                }
            })
        };
    } else {
        return {
            "type": "Polygon",
            "coordinates": coordinates[0],
        };
    }
}

export const generateFeatures = (feature, id, type) => {
    
    return {
    "type": "Feature",
    "id": id,
    "geometry": createGeometry(feature.geometry.coordinates, id),
    "properties": {
      ...feature.properties,
      "type": type, 
      "name": feature.properties.name,
      "color": feature.properties.color
    }
  }
};

export const convertToGeojson = (json, id, type) => {
    
    const features = [];
    json.features.forEach(feature => {
        features.push(generateFeatures(feature, id, type));
    });
    
    return {
        type: "FeatureCollection",
        features
    };
};